import { PageModel } from 'api/dto/Page.dto';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { Resource } from 'model/Resource';
import { LangCodeEnum } from 'shared/enums/LangCodeEnum';
import { languageConfig } from 'translations/languageConfig';

export const STORE_NAME = 'page';

export namespace PageState {
  export type Domain = {
    listResource: Resource<PageModel[]>;
    currentItem: PageItemModel;
    currentItemByLanguage: Record<LangCodeEnum, PageItemModel | null>;
    questionDetailsTab: number;
    languageTab: LangCodeEnum;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource(),
    currentItem: null,
    currentItemByLanguage: {} as Record<LangCodeEnum, PageItemModel | null>,
    questionDetailsTab: 1,
    languageTab: languageConfig.baseLanguage,
  };
}
